import { LogoIcon } from "@/components/ui/logo-icon";
import { cn } from "@/lib/utils";

/** Decorative lockup. Its enclosing home link supplies the accessible name. */
export function BrandLogo({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn("brand-logo", className)} aria-hidden="true">
      <LogoIcon className="brand-symbol" />
      {!compact && <span className="brand-wordmark">nreport<span className="brand-period" /></span>}
    </span>
  );
}
